import {Box, Button, Stack, Typography} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import * as React from 'react';
import {useState} from 'react';
import {isMailValid} from '../Service';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import AssociateBody from './AssociateBody';
import Switch from './Switch';
import {DIGITAL_SPONSOR, ENTOURAGE} from './constant';
import {useGodFather} from './hooks/useGodFather';
import {useSurroundings} from './hooks/useSurroundings';
import {
  withGodFatherContext,
  withSurroundingContext,
} from './state/associationContext';
import {useUserSubscription} from "../subscription/hook/useUserSubscription";

const Associate = () => {
  const [addSurroundingMode, setAddSurroundingMode] = useState(false);
  const [addGodFatherMode, setAddGodFatherMode] = useState(false);
  const {linkAccount} = useSurroundings();
  const {linkAccountGodFather, unlinkAccount} = useGodFather();
  const [newSurrounding, setNewSurrounding] = useState('');
  const [newGodFather, setNewGodFather] = useState('');
  const [isLoadingSurrounding, setIsLoadingSurrounding] = useState(false);
  const [isLoadingGodFather, setIsLoadingGodFather] = useState(false);
  const [helperMessage, setHelperMessage] = useState('');
  const {hasActiveSelfSubscription} = useUserSubscription();
  console.log('hasActiveSub', hasActiveSelfSubscription)
  const handleAddSurrounding = () => {
    setAddSurroundingMode(true);
    setAddGodFatherMode(false);
  };

  const handleAddGodFather = () => {
    setAddSurroundingMode(false);
    setAddGodFatherMode(true);
  };

  const handleLinkAccountSurrounding = () => {
    setHelperMessage('');
    if (isMailValid(newSurrounding)) {
      setIsLoadingSurrounding(true);
      linkAccount(newSurrounding, ENTOURAGE)
        .then(res => {
          if (res) {
            setHelperMessage('Votre demande a bien été envoyée');
          } else {
            setHelperMessage('Votre demande a échoué');
          }
          setNewSurrounding('');
          setIsLoadingSurrounding(false);
          setAddSurroundingMode(false);
        })
        .catch(res => {
            console.log('res', res)
          setHelperMessage(res.message ? res.message : 'Votre demande a échouée');
          setNewSurrounding('');
          setIsLoadingSurrounding(false);
          setAddSurroundingMode(false);
        });
    } else {
      setHelperMessage('Email invalide');
    }
  };

  const handleLinkAccountGodFather = () => {
    setHelperMessage('');
    if (isMailValid(newGodFather)) {
      setIsLoadingGodFather(true);
      linkAccountGodFather(newGodFather, DIGITAL_SPONSOR)
        .then(res => {
          if (res) {
            setHelperMessage('Votre demande a bien été envoyée');
          } else {
            setHelperMessage('Votre demande a échouée');
          }
          setNewGodFather('');
          setIsLoadingGodFather(false);
          setAddGodFatherMode(false);
        })
        .catch(res => {
            setHelperMessage(res.message ? res.message : 'Votre demande a échouée');
          setNewGodFather('');
          setIsLoadingGodFather(false);
          setAddGodFatherMode(false);
        });
    } else {
      setHelperMessage('Email invalide');
    }
  };
  const {mode} = useDarkMode();
  return (
    <Box
      sx={{
        backgroundColor: mode.settings.cardBackgroundColor,
        borderRadius: 1,
        padding: '20px',
      }}>
      <Stack gap={'5px'}>
          {hasActiveSelfSubscription() && <Stack direction={'row'} flexWrap={"wrap"} >
          <Stack gap={1}>
            <Typography variant={'subtitle7'} color={mode.settings.textColor6}>
              Comptes associés
            </Typography>
              <Typography variant={'subtitle3'} color={mode.settings.textColor6}>
                  Les comptes que vous avez désignés Entourage ou Parrain digital
              </Typography>
            <Typography
              variant={'h4'}
              color={mode.settings.textColor2}
              marginTop={'-7px'}>
              (5 comptes max)
            </Typography>
          </Stack>
          <Stack direction={'column'} flexWrap={"wrap"} gap={1} flexGrow={1} alignContent={'flex-end'} alignItems={'flex-end'}>
            <Stack direction={'row'} flexWrap={"wrap"} flexGrow={1}>
              {addSurroundingMode ? (
                  <>
                  <input
                    aria-label={'Ajout entourage'}
                    title={'contenu'}
                    className={'borderLessInput'}
                    value={newSurrounding}
                    onChange={event => setNewSurrounding(event.target.value)}
                    placeholder={'E-mail de votre entourage'}
                    style={{
                      color: mode.settings.textColor3,
                      backgroundColor: mode.settings.inputBackgroundColor,
                      paddingLeft: '15px',
                      flexGrow: 1
                    }}
                    id={'entourage'}
                  />
                  <Button
                    className={'borderLessButton'}
                    startIcon={
                      !isLoadingSurrounding ? (
                        <img
                          src={'/assets/icon/edit.png'}
                          alt={'Ajouter entourage'}
                          style={{marginRight: '10px'}}
                        />
                      ) : (
                        <CircularProgress color="inherit" size={20} />
                      )
                    }
                    onClick={() => handleLinkAccountSurrounding()}>
                    <Typography variant={'subtitle16'} component="span">
                      Ajouter
                    </Typography>
                  </Button>
                  </>
              ) : (
                <Button
                  className="btn"
                  style={{marginRight: {xs : '0px', md : '20px', lg : '20px'}, width : '241px'}}
                  onClick={() => handleAddSurrounding()}>
                  <img
                    src={'/assets/icon/edit.png'}
                    alt={'Ajouter Entourage'}
                    style={{marginRight: '10px'}}
                  />
                  <Typography variant={'subtitle16'} component="span">
                    Ajouter un entourage
                  </Typography>
                </Button>
              )}
              </Stack>

              <Stack direction={'row'} flexWrap={"wrap"} flexGrow={1}>
              {addGodFatherMode ? (
                  <>
                    <input
                      aria-label={'Ajout entourage'}
                      title={'contenu'}
                      className={'borderLessInput'}
                      name={'parrain'}
                      value={newGodFather}
                      onChange={event => setNewGodFather(event.target.value)}
                      placeholder={'E-mail de votre parrain'}
                      style={{
                        color: mode.settings.textColor3,
                        backgroundColor: mode.settings.inputBackgroundColor,
                        paddingLeft: '15px',
                        flexGrow: 1
                      }}
                      id={'parrain'}
                    />
                    <Button
                      className={'borderLessButton'}
                      startIcon={
                        !isLoadingGodFather ? (
                          <img
                            src={'/assets/icon/edit.png'}
                            alt={'Ajouter parrain digital'}
                            style={{marginRight: '10px'}}
                          />
                        ) : (
                          <CircularProgress color="inherit" size={20} />
                        )
                      }
                      onClick={() => handleLinkAccountGodFather()}>
                      <Typography variant={'subtitle16'} component="span">
                        Ajouter
                      </Typography>

                    </Button>
                  </>
              ) : (
                <Button className="btn" onClick={() => handleAddGodFather()} style={{width : '241px'}}>
                  <img
                    src={'/assets/icon/edit.png'}
                    alt={'Ajouter Parrain digital'}
                    style={{marginRight: '10px'}}
                  />
                  <Typography variant={'subtitle16'} component="span">
                    Ajouter un parrain digital
                  </Typography>
                </Button>
              )}
            </Stack>
          </Stack>
        </Stack>}
        <Typography
          variant={'subtitile3'}
          sx={{marginLeft: 'auto', color: mode.settings.textColor3, marginTop: '10px'}}>
          {helperMessage}
        </Typography>
          {hasActiveSelfSubscription() && <AssociateBody unlinkAccount={unlinkAccount}></AssociateBody>}
        {!localStorage.getItem('main_token') && <Switch></Switch>}
      </Stack>
    </Box>
  );
};

export default withGodFatherContext(withSurroundingContext(Associate));
